import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import SearchTransaction from "./searchTransaction.js";

function mapStateToProps(state) {
  return {
    simulatedUserDetails: state.simulatedUserDetails,
    isSimulateMode: state.isSimulateMode,
    searchTransactionResponse: state.searchTransactionResponse,
    userDetails: state.userDetails,
    dealerAccount: state.dealerAccount,
    relatedDealerAccount: state.dealerAccount.accounts,
    businessActivities: state.businessActivities,
    simulatedBusinessActivities: state.simulatedBusinessActivities,
    searchObj: state.searchObj,
    texts: state.translatedTexts,
    selectedTransactions: state.searchPageComponents.selectedTransactions,
    isTableVisible: state.searchPageComponents.isTableVisible,
    selectedTxnStatus: state.searchPageComponents.selectedTxnStatus,
    transactionStatus: state.transactionStatus,
    domainDetails: state.domainDetails
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchTransaction);
